import React, { Component } from 'react';

import { Container, Header, Title, Button, Icon, Tabs, Tab, Right, Left, Body } from 'native-base';

import TabOne from './tabOne';
import TabTwo from './tabTwo';
import TabThree from './tabThree';

class BasicTab extends Component {
	// eslint-disable-line

	render() {
		return (
			<Container>
				<Header hasTabs>
					<Left>
						<Button transparent onPress={() => this.props.navigation.goBack()}>
							<Icon name="arrow-back" />
						</Button>
					</Left>
					<Body>
						<Title> Basic Tabs</Title>
					</Body>
					<Right />
				</Header>

				<Tabs>
					<Tab heading="Tab1">
						<TabOne />
					</Tab>
					<Tab heading="Tab2">
						<TabTwo />
					</Tab>
					<Tab heading="Tab3">
						<TabThree />
					</Tab>
				</Tabs>
			</Container>
		);
	}
}

export default BasicTab;



// WEBPACK FOOTER //
// ./src/js/components/tab/basicTab.js